<template>
    <AdminLayout>
        <page-header title="My WASH Accounts" subtitle="Manage and track all your WASH accounts" :breadcrumbs="[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Wash', path: '/wash' }
        ]" :action="{
            label: 'Add WASH Account',
            icon: 'plus-lg',
            handler: addNewWashAccount
        }" />

        <WashCard :accounts="accounts" @remove="handleRemove" @view-bills="handleViewBills" />

    </AdminLayout>
    <FullscreenModal title="Water Bills" :show="showModal" @close="toggleModal">
        <WaterBillsViewer @pay-now="handlePayNow" @view-receipt="handleViewReceipt" :wbills="loadedBills" />
    </FullscreenModal>
    <ChildModal :show="showChildModal" @close="toggleChildModal">
        <SearchWashAccount @account-bound="getLinkedAccounts" @view-accounts="toggleChildModal" ref="searchAcctRef"/>
    </ChildModal>
    <FullscreenModal2 :show="showReceiptModal" @close="toggleReceiptModal">
        <Form51Receipt/>
    </FullscreenModal2>
</template>

<script setup>
import PageHeader from '@/components/commons/PageHeader.vue';
import WashCard from '@/components/commons/WashCard.vue';
import WaterBillsViewer from '@/components/infos/WaterBillsViewer.vue';
import SearchWashAccount from '@/components/inputs/SearchWashAccount.vue';
import ChildModal from '@/components/modals/ChildModal.vue';
import FullscreenModal from '@/components/modals/FullscreenModal.vue';
import FullscreenModal2 from '@/components/modals/FullscreenModal2.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import Form51Receipt from '@/receipts/Form51Receipt.vue';
import confirmationService from '@/services/confirmationService';
import paymentService from '@/services/paymentService';
import spinnerService from '@/services/spinnerService';
import toastService from '@/services/toastService';
import washService from '@/services/washService';
import { nextTick, onMounted, ref } from 'vue';
const accounts = ref([]);
const loadedBills = ref([]);
const showModal = ref(false);
const showChildModal = ref(false);
const toggleModal = () => {
    showModal.value = !showModal.value;
}
const addNewWashAccount = () => {
    toggleChildModal();
    nextTick(()=>{
        searchAcctRef.value?.resetSearch();
    })
}

const handleViewReceipt = ()=>{
    toggleReceiptModal();
}

const handlePayNow = async (bill)=>{
    spinnerService.show();
    const payload = {
        item_id: bill.strSysPK,
        account_no: selectedAccount.value.account,
        account_name: selectedAccount.value.account_name,
        amount: bill.billAmount_CtrctTrans 
    };
    const resp = await paymentService.initiateWBPayment(payload)
    if(resp.success){
        window.location.href=resp.url;
    }
    else{
        toastService.error(resp.message);
    }
    spinnerService.hide();
}

const showReceiptModal = ref(false);
const toggleReceiptModal  =()=>{
    showReceiptModal.value = !showReceiptModal.value;
}

const toggleChildModal = () => {
    showChildModal.value = !showChildModal.value;
}

const searchAcctRef = ref(null);



const handleRemove = async (account) => {
    const confirmed = await confirmationService.show(`Are you sure you want to remove this account: ${account.account_name}?`);
    if (!confirmed) return;
    spinnerService.show();
    const resp = await washService.removeAccount(account.account);
    if (resp.success) {
        toastService.success("Account removed successfully!")
        getLinkedAccounts();
    }
    else {
        toastService.error(resp.message);
    }
    spinnerService.hide();
}

const getLinkedAccounts = async () => {
    spinnerService.show();
    accounts.value = await washService.getLinkedAccounts();
    spinnerService.hide();
}
const selectedAccount =  ref({});
const handleViewBills = async (account) => {
    selectedAccount.value = account;
    spinnerService.show();
    toggleModal();
    loadedBills.value = await washService.getBillsByAcctNo(account.account)
    spinnerService.hide();

}

onMounted(() => {
    getLinkedAccounts();
});

</script>